import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const COMMON_REASONS = ['Hemolyzed', 'Clotted', 'Insufficient volume', 'Wrong container', 'Unlabeled / mislabeled', 'Leaked'];

// Asks for the rejection reason (required by the API) before rejecting a sample.
export default function RejectSampleDialog({ sample, onClose, onConfirm }) {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleClose = () => {
    if (submitting) return;
    setReason('');
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) return;
    setSubmitting(true);
    try {
      await onConfirm(reason.trim());
      setReason('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={!!sample} onClose={handleClose} fullWidth maxWidth="xs" className="common-modal">
      <DialogTitle className="d-flex justify-content-between align-items-center">
        Reject sample {sample?.sampleNo}
        <IconButton onClick={handleClose} className="common-cross-button">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <label className="common-Labels d-block">Reason <span className="common-Asterisk">*</span></label>
          <div className="d-flex flex-wrap gap-1 mb-2">
            {COMMON_REASONS.map((r) => (
              <Button key={r} size="small" variant="outlined" onClick={() => setReason(r)} style={{ textTransform: 'none', fontSize: '11px' }}>
                {r}
              </Button>
            ))}
          </div>
          <textarea
            className="form-control common-Input"
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Why is this sample rejected?"
            required
          />
          <div className="common-Font-10 text-muted mt-1">
            The sample's tests become pending again so a new sample can be collected.
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
          <Button type="submit" variant="contained" color="error" disabled={submitting || !reason.trim()}>
            {submitting ? 'Rejecting...' : 'Reject'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
